import type { StoreApp } from '~/domain/dashboard/app/apps/models/App'
import { STORE_APP_INTERNAL_NAME_MAX_LENGTH } from '~/domain/dashboard/store/constants/storeBasicInfoLimits'

/**
 * Internal `app.name` (max 40) for a store.
 *
 * The internal name is a pure derivation of the display name, so it stays in
 * sync on both create and update. Historically it was kept untouched on update
 * (`if (model.id) return model.name`), which sent an empty `name` on `PUT /apps/{id}`
 * whenever the in-memory model had not been refreshed after create — the backend
 * rejects that with `name Required`.
 *
 * Falls back to the existing internal name only when the display name is empty
 * (should not happen for a valid store, as the display name is required).
 */
export function resolveStoreAppInternalName (model: StoreApp): string {
  const displayName = model.settings.basicInfo.name?.trim() ?? ''
  if (displayName) {
    return displayName.slice(0, STORE_APP_INTERNAL_NAME_MAX_LENGTH)
  }

  return model.name ?? ''
}
